import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Heading for search result list
 *  
 * Example output: 
 * 
 ```html
 <h2><span class="t-total-hits">12</span> sökträffar på <strong>feber</strong></h2>
 ```
 *
 */
const SearchHeading = ({
  hideSearchHeading,
  TotalHits,
  ResultText,
  SuggestionText,
  ContentAfter = '',
  query,
  Modifiers,
  activeFilterFacet,
  showFilterResultText,
  translations,
  isVardpersonal1177,
  siteAdress,
}) => {
  if (hideSearchHeading) return null;
  if (!query && TotalHits === 0) return null;

  SuggestionText
    ? (SuggestionText.Query = decodeURIComponent(SuggestionText.Query))
    : null;

  const componentClass = classNames({
    'c-searchlist__heading': true,
    ...Modifiers,
  });

  const resultQueryText = query ? <strong>{query}</strong> : null;

  const filterResultText =
    showFilterResultText && activeFilterFacet ? (
      <>
        {isVardpersonal1177 ? translations.withfilter : translations.within}{' '}
        <strong>{activeFilterFacet}</strong>{' '}
      </>
    ) : null;

  const resultSiteText = siteAdress ? (
    <>
      {translations.on} {translations.site} <strong>{siteAdress}</strong>
    </>
  ) : null;

  return (
    <h2 className={componentClass}>
      <span className="t-total-hits" data-cy="ui-searchform-totalhits">
        {TotalHits}
      </span>{' '}
      {ResultText} {resultQueryText} {filterResultText} {resultSiteText}
      {SuggestionText && SuggestionText?.Query && (
        <span>
          . {SuggestionText.Text}{' '}
          <a href={SuggestionText.Url}>{SuggestionText.Query}</a>?
        </span>
      )}{' '}
      {ContentAfter}
    </h2>
  );
};

SearchHeading.propTypes = {
  /** If `true` component will not render */
  hideSearchHeading: PropTypes.bool,
  TotalHits: PropTypes.number,
  ResultText: PropTypes.string,
  showFilterResultText: PropTypes.bool,
  translations: PropTypes.objectOf(PropTypes.string),
  activeFilterFacet: PropTypes.string,
  SuggestionText: PropTypes.shape({
    Text: PropTypes.string,
    Url: PropTypes.string,
    Query: PropTypes.string,
  }),
  ContentAfter: PropTypes.node,
  query: PropTypes.string,
  Modifiers: PropTypes.object,
  isVardpersonal1177: PropTypes.bool,
};

export default SearchHeading;
